function setFormErrorMessages({ input, state }) {
  if (input.result.errors) {
    input.result.errors.forEach(error => {
      let path = `client.registrating.current.${error.path}`
      let current = state.get(path)
      let field = state.get(`${path}.${error.key}`)
      let validations = field.validations || []
      let errorMessages = field.errorMessages || []
      if (
        error.errorHandler === 'notEqualTo' &&
        validations.indexOf(`notEqualTo:"${current[error.key].value}"`) === -1
      ) {
        state.set(`${path}.${error.key}`, {
          ...field,
          validations: [
            ...validations,
            `notEqualTo:"${current[error.key].value}"`
          ],
          errorMessages: [
            ...errorMessages,
            { key: `bus-client.${error.errorMessage}` }
          ],
          isValid: false,
          errorMessage: { key: `bus-client.${error.errorMessage}` }
        })
      } else {
        state.merge(`${path}.${error.key}`, {
          isValid: false,
          errorMessage: { key: `bus-client.${error.errorMessage}` }
        })
      }
    })
  }
}

export default setFormErrorMessages



// WEBPACK FOOTER //
// ./src/modules/user/actions/setFormErrorMessages.js